/**
 * SecretEntry — small subtle clickable thumbnail of the Colosseum arch door.
 * Sits to the right of the "Access All Areas" header in the hamburger menu.
 * No animations beyond a gentle hover scale. Tap → /discover-colosseum.
 */
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const DOOR_URL = `${BACKEND_URL}/api/uploads/static/colosseum_door.jpg?v=2`;

const SecretEntry = ({ onClick }) => {
  const navigate = useNavigate();
  const handle = () => {
    onClick && onClick();
    navigate('/discover-colosseum');
  };
  return (
    <button
      type="button"
      onClick={handle}
      data-testid="secret-entry-door"
      aria-label="Discovering the Colosseum"
      title="Discovering the Colosseum"
      className="group/door relative shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-md overflow-hidden border border-[#D4AF37]/30 hover:border-[#D4AF37]/70 hover:shadow-[0_0_12px_rgba(212,175,55,0.25)] transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/60"
    >
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-500 ease-out group-hover/door:scale-[1.06]"
        style={{ backgroundImage: `url(${DOOR_URL})`, backgroundPosition: 'center 40%' }}
        aria-hidden
      />
      <div className="absolute inset-0 pointer-events-none" style={{boxShadow: 'inset 0 0 6px rgba(0,0,0,0.55)'}} aria-hidden />
    </button>
  );
};

export default SecretEntry;
